import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { modelClass } from '/imports/api/prospectBatches';
import { PageHeading } from '/imports/ui/PageHeading';
import { Button } from '/imports/ui/Button';
import { useHasProspector, useUser } from '/imports/hooks';
import { toastOnError } from '/imports/ui/utils';
import { formatDateTime } from '/imports/utils';
import { strings } from '/imports/strings';

/** Lists prospect batches and creates new ones. */
export const ProspectBatchesPage = () => {
  const canProspect = useHasProspector();
  const user = useUser();
  const navigate = useNavigate();
  const createNew = toastOnError(async () => {
    if (!user?.orgId) return;
    const _id = await modelClass.createMethod.call({
      active: true,
      orgId: user.orgId,
      name: new Date().toLocaleString(),
    });
    navigate(`${modelClass.pathPrefix}/${_id}`);
  });
  return <ModelListPage
    permission={() => canProspect}
    modelClass={modelClass}
    header={(
      <PageHeading
        left={<h1>Prospector</h1>}
        right={
          <div className="buttons">
            <Button className="btn primary" onClick={() => createNew()}>{strings.New()}</Button>
          </div>
        }
      />
    )}
    columns={[
      { field: 'name', render: (doc) => <Link to={`${modelClass.pathPrefix}/${doc._id}`}>{doc.name}</Link> },
      { field: 'createdAt', render: (doc) => <span>{doc.createdAt && formatDateTime(doc.createdAt)}</span> },
    ]}
    defaultSort={{ createdAt: -1 }}
  />;
};
